// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"710":"edf48090","943":"d7c62ec4"}[chunkId] + ".chunk.js";
};